export const FHIR_QueryKeys = [
    'AllergyIntolerance',
    'Diagnoses',
    'Infection',
    'MedicalHistory',
    'DiagnosticReportResults',
    'ClinicalNotes',
    'EncounterResource',
    'FamilyMemberHistory',
    'Immunization',
    'ListAllergies',
    'ListFamilyHistory',
    'ListImmunizations',
    'ListMedications',
    'ListProblems',
    'MedicationResource',
    'LabResults',
    'VitalSigns',
    'PatientResource',
    'ProcedureOrders',
    'ProcedureSurgeries',
    'SurgicalHistory',
    'ServiceRequestOrders',
];
export const FHIR_VarResolverTypes = [
    'Resolver_Codeable',
    'Resolver_Profile',
];
//# sourceMappingURL=core.js.map